import { getData } from "./ApiService";

export const GetOffices = async () => {
  return getData("offices");
};

export const GetGroupsForOffices = async (officeId) => {
  return getData(`offices/${officeId}/groups`);
};
